const obj = {
  user_status: {
    owner: "OW",
    sub_owner: "SOW",
    super_admin: "SSSSS",
    admin: "SSSS",
    sub_admin: "SSS",
    senior_super: "SS",
    super_agent: "SUP",
    agent: "MA",
    user: "PL",
  },


  new_user_status: {
    super_admin: "SSSSS",
    admin: "SSSS",
    sub_admin: "SSS",
    senior_super: "SS",
    super_agent: "SUP",
    agent: "AG",
    user: "CL",
  },
  betCheckData3: [
    {
      value: "Cricket",
      label: "4",
    },
    {
      value: "Tennis",
      label: "2",
    },
    {
      value: "Soccer",
      label: "1",
    },
    {
      value: "Casino",
      label: "3",
    },
    {
      value: "Parlay",
      label: "parlay",
    },
  ],
  user_next_status: {
    owner: "sub_owner",
    sub_owner: "super_admin",
    super_admin: "admin",
    admin: "sub_admin",
    sub_admin: "senior_super",
    senior_super: "super_agent",
    super_agent: "agent",
    agent: "user",
  },

  user_next_status_only_status: {
    owner: "sub_owner",
    sub_owner: "super_admin",
    super_admin: "admin",
    admin: "owner",
    sub_admin: "super_super",
    senior_super: "super",
    super_agent: "master_agent",
    agent: "player",
  },
  betCheckObjNew: {
    cricket: 4,
    tennis: 2,
    soccer: 1,
    casino: 3,
  },
  market_Status: {
    1: "Open",
    2: "In Active",
    3: "Suspended",
    4: "Closed",
    9: "Ball Start",
  },
  market_category: {
    1: "Market",
    3: "Bookmakers",
    5: "ManualOdds",
    10: "Win Toss",
    2: "Session",
    6: "Over by Over Session Market",
    7: "Player",
    9: "Wicket",
    11: "Bowler Session",
    8: "Last Digit ODD",
    4: "LineMarket",
    14: "Premium ODDs",
  },
  settingHeading: {
    bookmaker: "Bookmaker Listing",
    betFaire: "Bet Fair Listing",
    fancy: "Fancy Listing",
    sportBook: "Premium Fancy Listing",
    completedMatch: "Completed Match",
    preCompletedMatch: "Pre Completed Match",
    tiedMatch: "Tied Match",
    preTiedMatch: "Pre Tied Match",
    toWintheToss: "To Win the Toss",
    preBetFaire: "Pre BetFaire",
    goalUnderOver: "Goal Under Over",
    
  },
  settingArray: [
  
    // {
    //   type: "preTiedMatch",
    //   minAmount: "",
    //   maxAmount: "",
    //   betDelay: "",
    //   onShow: 0,
    //   oddsLimit: "",
    //   maxProfit: "",
    //   maxError: false,
    // },
    // {
    //   type: "tiedMatch",
    //   minAmount: "",
    //   maxAmount: "",
    //   betDelay: "",
    //   onShow: 0,
    //   oddsLimit: "",
    //   maxProfit: "",
    //   maxError: false,
    // },
    // {
    //   type: "preCompletedMatch",
    //   minAmount: "",
    //   maxAmount: "",
    //   betDelay: "",
    //   onShow: 0,
    //   oddsLimit: "",
    //   maxProfit: "",
    //   maxError: false,
    // },
    // {
    //   type: "completedMatch",
    //   minAmount: "",
    //   maxAmount: "",
    //   betDelay: "",
    //   onShow: 0,
    //   oddsLimit: "",
    //   maxProfit: "",
    //   maxError: false,
    // },
    
    // {
    //   type: "preBetFaire",
    //   minAmount: "",
    //   maxAmount: "",
    //   betDelay: "",
    //   onShow: 0,
    //   oddsLimit: "",
    //   maxProfit: "",
    //   maxError: false,
    // },
    {
      type: "betFaire",
      minAmount: "",
      maxAmount: "",
      betDelay: "",
      onShow: 0,
      oddsLimit: "",
      maxProfit: "",
      maxError: false,
    },
    {
      type: "bookmaker",
      minAmount: "",
      maxAmount: "",
      betDelay: "",
      onShow: 0,
      oddsLimit: "",
      maxProfit: "",
      maxError: false,
    },
    {
      type: "fancy",
      minAmount: "",
      maxAmount: "",
      betDelay: "",
      onShow: 0,
      oddsLimit: "",
      maxProfit: "",
      maxError: false,
    },
    {
      type: "sportBook",
      minAmount: "",
      maxAmount: "",
      betDelay: "",
      onShow: 0,
      oddsLimit: "",
      maxProfit: "",
      maxError: false,
    },
 
    
   
    // {
    //   type: "toWintheToss",
    //   minAmount: "",
    //   maxAmount: "",
    //   betDelay: "",
    //   onShow: 0,
    //   oddsLimit: "",
    //   maxProfit: "",
    //   maxError: false,
    // },
    // {
    //   type: "goalUnderOver",
    //   minAmount: "",
    //   maxAmount: "",
    //   betDelay: "",
    //   onShow: 0,
    //   oddsLimit: "",
    //   maxProfit: "",
    //   maxError: false,
    // },
  ],
  betCheckData2: [
    {
      value: "Cricket",
      label: "4",
    },
    {
      value: "Tennis",
      label: "2",
    },
    {
      value: "Soccer",
      label: "1",
    },
  ],
  messageType: {
    downline: "Downline",
    all: "All",
    user: "User",
  },

  betCheckData: [
    {
      value: "Cricket",
      label: "4",
    },
    {
      value: "Tennis",
      label: "2",
    },
    {
      value: "Soccer",
      label: "1",
    },
    {
      value: "Casino",
      label: "3",
    },
  ],
  betCheckObj: {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  },
  betCheckDataLabel: [
    {
      value: "Cricket",
      label: "cricket",
    },
    {
      value: "Tennis",
      label: "tennis",
    },
    {
      value: "Soccer",
      label: "soccer",
    },
    {
      value: "Casino",
      label: "casino",
    },
  ],
  betCheckDataInner: [
    {
      value: "Exchange",
      label: "betfair",
    },
    {
      value: "Bookmaker",
      label: "bookmaker",
    },
    {
      value: "Fancy",
      label: "fancy",
    },
    {
      value: "SportsBook",
      label: "sportBook",
    },
    {
      value: "Tie",
      label: "tie",
    },
    {
      value: "Toss",
      label: "toss",
    }
  ],
  matchType: {
    cricket: "Cricket",
    tennis: "Tennis",
    soccer: "Soccer",
    casino: "Casino",
  },
  homeCasino : [
    
    {
      casino: "kingmaker",
      name:"Baccarat",
      platForm: "KINGMAKER",
      gameType: "TABLE",
      casinoType:"KM-TABLE-026",
      image: "assets/images/home/KM-TABLE-026.png",
    },
    {
      casino: "kingmaker",
      name:"Coin Toss",
      platForm: "KINGMAKER",
      gameType: "TABLE",
      casinoType:"KM-TABLE-036",
      image: "assets/images/home/KM-TABLE-036.png",
    }]
  ,
  betCheckData2: [
    {
      value: "Cricket",
      label: "4",
    },
    {
      value: "Tennis",
      label: "2",
    },
    {
      value: "Soccer",
      label: "1",
    },
  ],
   
};

export default obj;

export const headerDataBetHistory = [
  {
    class: "text-start",
    title: "Bet ID",
    widht: "",
  },  {
    class: "text-start",
    title: "PL ID",
    widht: "",
  },
  {
    class: "text-start",
    title: "Market",
    widht: "30%",
  },
  {
    class: "text-end",
    title: "Selection",
    widht: "",
  },
  {
    class: "text-end",
    title: "Type",
    widht: "",
  },
  {
    class: "text-end",
    title: "Bet placed",
    widht: "",
  },
  {
    class: "text-end",
    title: "Odds req.",
    widht: "",
  },
  {
    class: "text-end",
    title: "Stake",
    widht: "",
  },
  {
    class: "text-end",
    title: "Avg. odds matched",
    widht: "",
  },
  {
    class: "text-end",
    title: "Profit/Loss",
    widht: "",
  },

];
export function formatNumber(number) {
  // Multiply by 100, floor the number to remove any decimals after two digits, then divide by 100
  const formattedNumber = Math.floor(number * 100) / 100;
  return formattedNumber;
}
export const preventMaxInput = (e) => {
  e.target.value = e.target.value.trimStart();
  e.target.value = e.target.value.replace(/  +/g, " ");
};